<template>
	<div class="investmentClues" data-title="重点城市的重点产业线索">
		<leftnav class="fl" mkcode="C"
			itemcode="C-ZDCSZDCY"></leftnav>
		<div class="index_left" :style="isCollapse ? 'margin-left: 0;width:100%' : ''">
			<govheader></govheader>
			<el-dialog class="localChain" title="" :visible.sync="isShowFreeUserTips" width="650px" top="20vh">
				<freeUserTips :type="4" :bgtype="0"></freeUserTips>
			</el-dialog>
			<div class="index_left_centerpage">
				<!-- 头部盒子开始 -->
				<div class="whitebox right_topbox " style="padding-bottom: 5px;">
					<div class="right_boxtitle">
						<span class="fl right_title"
							v-if="curWebsite.type != 5 && curWebsite.type != 6">{{ curWebsite.keyword }}{{ curWebsite.type
								== 2 ? '' :'线索'}}</span>
						<span class="fl right_title" v-if="curWebsite.type == 6">产业排行榜</span>
						<cluetips></cluetips>
						<span class="fr showechart-c6" @click="showechart = !showechart">{{ showechart ? '隐藏' : '查看' }}图表</span>
						<video-teaching :type="3" seat="top"></video-teaching>
					</div>
					<!-- 筛选项开始 -->
					<div class="opport-screen-list1">
						<div class="spage-searchbox ">
							<ClueNav tabCode="zdcszdcy"></ClueNav>
						</div>
						<dl class="opport-screen bdbe">
							<dt class="fl">重点城市</dt>
							<dd class="fl">
								<span :class="{ 'a-screen': true, 'current': cityid == item.id || proid == item.id }"
									v-for="item in hotcitylist" :key="item.id"
									@click="getcityid(item)">{{ item.name }}</span>
							</dd>
						</dl>
						<dl class="opport-screen bdbe">
							<dt class="fl">重点产业</dt>
							<dd class="fl">
								<span :class="{ 'a-screen': true, 'current': notioncode1 == item.notionCode }"
									v-for="(item, index) in hotnotionlist" :key="'hotNotion' + index"
									@click="getnotioncode(item, index, 1)">{{ item.notionName }}<em
										class="num">({{ item.num }})</em></span>
							</dd>
						</dl>
						<dl class="opport-screen bdbe" v-show="hotnotionchildren.length > 1">
							<dt class="fl titleop">细分产业</dt>
							<dd class="fl">
								<span :class="{ 'a-screen': true, 'current': notioncode2 == item.notionCode }"
									v-for="(item, index)  in hotnotionchildren" :key="'hotNotionT' + index"
									@click="getnotioncode(item, index, 2)">{{ item.notionName }}<em
										class="num">({{ item.num }})</em></span>
							</dd>
						</dl>
					</div>
					<!-- 筛选项结束 -->
				</div>
				<!-- 头部盒子结束 -->
				<!-- 柱状图 概念企业数量 -->
				<div class="fixedEchartBar" v-show="showechart">
					<div id="fixedEchartBar" class="fl"></div>
					<h4 class="title">{{ cityname }}重点产业分布</h4>
					<div id="fixedEchartPie" class="fr"></div><span class="closebtn" @click="showechart = false"></span>
				</div>
				<!-- 表格内容开始 -->
				<div class="whitebox columnbox">
					<div class="enterparise_guide oh" style="width: 95%; ">
						<p class="fl">产业大脑为您找到<span class="searchnum">{{ total }}</span>条相关结果</p>
					</div>
					<!-- 多维度分数筛选 -->
					<ul class="dimensionScreen oh w95mg">
						<li :class="orderField == list.type ? 'fl current ' : 'fl '" v-for="(list, index) in dimensionList"
							:key="'order' + index" @click="tablesort(list.type);"><span
								:class="{ 'sortname ': true, 'current': orderField == list.type, 'fz15': list.name.length > 5 }">{{ list.name }}</span><span
								:class="orderType == 1 ? 'timesorticon up' : 'timesorticon down'"></span></li>
					</ul>
					<!-- 热门产业全部企业 -->
					<div class="enterprise_list_box" v-show="enterpristlist.length != 0">
						<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table">
							<tr>
								<th>排名</th>
								<th>企业名称</th>
								<th>所属产业</th>
								<th>画像标签</th>
								<th>地区</th>
								<th>企业实力</th>
								<th>投资力度</th>
								<th>编辑</th>
							</tr>
							<tr v-for="(list, index) in enterpristlist" :key="list.title + list.stockCode">
								<td>{{ (page - 1) * pageSize + index + 1 }}</td>
								<td class="title" @click="routerlinkid('/enterprises', list.stockCode, 9, '', curindex)">
									{{ list.title }}</td>
								<td class="conpanytags hastag">
									<span class="span-tag" v-for="item in list.notionlist" :key="item.id"
										@click="tagrouter('/enterpriseTag', 0, 'notion', item.id, item.name, 'all')">{{ item.name }}</span>
								</td>
								<td class="conpanytags hastag">
									<span class="span-tag" v-for="item in list.taglist" :key="item.id"
										@click="tagrouter('/enterpriseTag', 0, 'tag', item.id, item.name, 'all')">{{ item.name }}</span>
								</td>
								<td>{{ list.area }}</td>
								<td>{{ list.zs100000 }}</td>
								<td>{{ list.zs200000 }}</td>
								<td class="collectfont1"><span @click="listToggleCollect(list)">{{ list.collectId ==
									0 ?'加入':'移除'}}<br />目标企业</span></td>
							</tr>
						</table>
					</div>
					<!-- 表格内容结束 -->
					<div class="centerpage1 company_pagelist" v-show="totalPage > 1">
						<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total"
							v-bind:max-page="maxPage" v-on:pagehandler="pageHandler">
						</zpagenav>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { dataInJs } from "../../utils/city.js";
import { mapState, mapMutations, mapGetters } from "vuex";

export default {
	name: 'investmentClues6',
	computed: {
		...mapState({
			isCollapse: (state) => state.isCollapse,
		}),
		...mapGetters(['isCollapse'])
	},
	data() {
		return {
			title: "重点城市的重点产业线索",
			userdata: {}, curWebsite: this.$api.getWebsiteType(), showechart: true,
			searchtype: 5,//线索类型 2以商招商 1本省投资概率 3关键融资 4热点产业企业 5.重城重产 
			hotcitylist: [
				{ id: 11, name: "北京" }, { id: 31, name: "上海" }, { id: 4403, name: "深圳" }, { id: 3301, name: "杭州" }, { id: 3205, name: "苏州" }, { id: 4401, name: "广州" }, { id: 3201, name: "南京" }, { id: 5101, name: "成都" },
				{ id: 3302, name: "宁波" }, { id: 3202, name: "无锡" }, { id: 4301, name: "长沙" }, { id: 3306, name: "绍兴" }, { id: 4201, name: "武汉" }, { id: 3401, name: "合肥" }, { id: 12, name: "天津" }, { id: 50, name: "重庆" },
				{ id: 3502, name: "厦门" }, { id: 3310, name: "台州" }, { id: 3204, name: "常州" }, { id: 3702, name: "青岛" }
			],
			hotnotionlist: [{ notionCode: "A01,A02,A03,A04,A05,A06", notionName: '全部', num: 1990, children: [] }],
			colors: ['#5E83CC', '#ffbb1c', '#47a59d', "#f60", "#ff0", "#f87f8f"], notionstyles: "all",
			allnotionlist: [{ notionCode: "A01,A02,A03,A04,A05,A06", notionName: '全部', num: 1990, children: [] }],
			notionlistApi: [],//api后台概念数据
			hotnotionchildren: [], childreAllString: '', notioncode1: "A01,A02,A03,A04,A05,A06", notioncode2: "",
			flages: true,
			// notionCodearr:[{code:'A0101'},{'A0201'},{'A0301'},{'A0501'},{'A0502'},{'C01'},{'A0308'},{'A0313'},{'A0317'},{'A0504'},{'A0601'}], 
			proid: 11, cityid: 0, notionCode: "A01,A02,A03,A04,A05,A06", cityname: "北京市",
			enterpristlist: [],
			page: 1,  //显示的是哪一页
			haspage: true,//是否还有下一页
			pageSize: 10, //每一页显示的数据条数
			total: 0, //记录总数 
			totalPage: 1,
			maxPage: 10,  //最大页数  
			areadata: dataInJs(), //省份城市数据
			orderField: 0,//排序字段 0 分数 1 时间
			orderType: 0,//排序方式 0 降序 1 升序 
			// 0=分数,1=融资时间,2=企业实力,3=投资力度,4=本省关联度,5=拿地数量,6=拿地面积,7=拿地金额,8=投资项目数量,9=投资项目金额,10=控制企业数量,11=专利数量
			dimensionList: [{ name: '综合', type: 0 }, { name: '企业实力', type: 2 }, { name: '投资力度', type: 3 }, { name: '本省关联度', type: 4 }, { name: '拿地数量', type: 5 }, { name: '拿地面积', type: 6 }, { name: '拿地金额', type: 7 }, { name: '投资项目数量', type: 8 }, { name: '投资项目金额', type: 9 }],
			// ,{name:'控制企业数量',type:10},{name:'专利数量',type:11},
			isShowFreeUserTips: false,
		}
	},
	created() {
		this.$nextTick(() => {
			// 禁用右键
			document.oncontextmenu = new Function("event.returnValue=false");
			// 禁用选择
			document.onselectstart = new Function("event.returnValue=false");
		});
		var _this = this;
		this.userdata = this.getuseriformation();

	},
	mounted() {
		document.getElementById('app').style.background = "#f0f3f5";
		this.getcompanylist(1, 'city', this.notionstyles);
		this.getapiNotionlist();
	},
	methods: {
		//获取后台api的三大概念数据存值
		getapiNotionlist() {
			var _this = this;
			this.$axios.get(this.$api.tag.notion.list() + '?level=3').then(function (res) {
				// console.log(res.data)
				if (res.data.success) {
					// console.log('三大产业概念数据',res.data.list)
					res.data.list.forEach(list => {
						if (list.value == 'A') {
							_this.notionlistApi = list.children;
						};
					});
					// console.log(_this.notionlistApi)
				} else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		//热门城市点击
		getcityid(list) {
			this.isShowFreeUserTips = true;
			return;
			if (list.id < 100) {
				this.proid = list.id;
				this.cityid = 0;
			} else {
				this.proid = 0;
				this.cityid = list.id;
			}
			this.cityname = list.name;
			this.notionCode = this.allnotionlist[0].notionCode;
			this.notioncode1 = this.allnotionlist[0].notionCode;
			this.hotnotionchildren = [];
			this.getcompanylist(1, 'city', 'all');
		},
		//热门产业点击
		getnotioncode(list, indexs, type) {
			this.isShowFreeUserTips = true;
			return;
			if (list.notionCode == this.notionCode) {
				return;
			}
			if (type == 1) {
				//一级分类点击
				console.log(list);
				if (indexs == 0) {
					this.notionCode = list.notionCode; type = 'all';
				} else {
					var testcode = "";
					this.notionlistApi.forEach(datas => {
						// console.log(datas.children,list.notionCode,datas.value)
						if (datas.value == list.notionCode) {
							this.hotnotionchildren = [{ notionCode: list.notionCode, notionName: '全部', num: 1990 }];
							for (var i = 0; i < datas.children.length; i++) {
								var douhao = i == 0 ? '' : '%2C';
								testcode = testcode + douhao + datas.children[i].value;
							}
							this.notionCode = testcode;
						};
					});
				}
				this.notioncode1 = list.notionCode;
				this.notioncode2 = list.notionCode;
				this.getcompanylist(1, 'city', type);
			} else if (type == 2) {
				this.notionCode = list.notionCode;
				this.notioncode2 = list.notionCode;
				this.getcompanylist();
			}
			this.notionstyles = type;
			console.log('hotnotionchildren', this.notionCode)
			// this.notionCode=list.notionCode;

		},
		// pageHandler: function (page) {
		// 	this.page = page; 
		// 	this.getcompanylist(page); 
		// },
		pageHandler: function (page) {
			if (page > 1) {
				this.isShowFreeUserTips = true;
				return;
			}
			this.getcompanylist(page);
		},
		//时间/分数升降序
		tablesort(field) {
			this.isShowFreeUserTips = true;
			return;
			if (field == this.orderField) {
				this.orderType = Math.abs(this.orderType - 1);
			} else {
				this.orderField = field;
			}
			this.getcompanylist();
		},
		getcompanylist(page, type, notiontype) {
			this.bus.$emit('loading', true);
			// console.log('getcompanylist');
			this.page = page ? page : 1;
			var _this = this;
			//获取企业列表
			var notionja = this.splicing('notion', this.notionCode);
			var cityja = this.splicing('city', this.cityid);
			var provja = this.splicing('province', this.proid);
			var ajaxurl = this.$api.free.industryRank.cityIndustryRank();
			console.log(ajaxurl);
			this.$axios.get(ajaxurl).then(function (res) {
				// console.log('省份城市列表',res.data)
				var notionlistAjax = res.data.extend.cityNotionList;
				if (res.data.success) {

					if (_this.notionCode.length > 10 && type == 'city') {
						console.log('全部');
						let arr = [], arr1 = [];
						// 将需要排序的 key, 按照 "从大到小" 进行排列
						let sortKeys = Object.keys(notionlistAjax).sort((a, b) => {
							return notionlistAjax[b].num - notionlistAjax[a].num;
						})
						// 循环排列好的 key, 重新组成一个新的数组
						for (var sortIndex in sortKeys) {
							arr.push(notionlistAjax[sortKeys[sortIndex]])
							arr1.push(notionlistAjax[sortKeys[sortIndex]])
						}
						var arrJie = arr;
						if (notiontype == 'all') {
							_this.allnotionlist[0].num = res.data.totalRecord;
							_this.hotnotionlist = _this.allnotionlist.concat(arr);
							// arrJie=arr;
						} else if (notiontype == 1) {
							_this.hotnotionchildren[0].num = res.data.totalRecord;
							_this.hotnotionchildren = _this.hotnotionchildren.concat(arr);
							console.log(arr.length);
							if (arr1.length > 6) {
								arrJie = arr.splice(0, 6);
								var qitanum = 0;
								for (var d = 6; d < arr1.length; d++) {
									console.log(arr1.length, d, arr1[d].notionName)
									qitanum = arr1[d].num + qitanum;
								}
								arrJie.push({ areaId: 9999, notionCode: "0", notionName: "其他", num: qitanum });
							}
						}
						_this.rankFun('fixedEchartBar', arrJie);
						_this.PiechartFun('fixedEchartPie', arrJie);
						_this.flages = false;
					}
					console.log('获取企业列表', res.data);
					_this.enterpristlist = res.data.list;
					for (var i = 0; i < res.data.list.length; i++) {
						_this.enterpristlist[i].taglist = _this.taglistfun(_this.enterpristlist[i].tag, _this.enterpristlist[i].tagCode);
						_this.enterpristlist[i].notionlist = _this.taglistfun(_this.enterpristlist[i].notion, _this.enterpristlist[i].notionCode);
					}

					_this.totalPage = res.data.totalPage;
					_this.pageSize = res.data.pageSize;
					_this.total = res.data.totalRecord;
					_this.haspage = res.data.list.length == res.data.pageSize;
					_this.kwtextsearch = _this.searchtext != ''
					_this.kwtextsearchtext = _this.searchtext;
					_this.bus.$emit('loading', false);
				} else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		//弹出图表 概念企业数量排名
		rankFun(el, data) {
			var charPie3currentIndex = 0,
				isSet = true; //为了做判断：当鼠标移动上去的时候，自动高亮就被取消
			var chart = echarts.init(document.getElementById(el));
			var _this = this,
				xline = [],
				seriesline = [];
			var datalen = data.length - 1;
			for (var i = 0; i < data.length; i++) {
				xline.push(data[datalen - i].notionName);
				seriesline.push(data[datalen - i].num);
			};
			// console.log(data,xline,seriesline)
			var option = {
				title: {
					// text:_this.cityname+'重点产业',
					text: '',
					right: 0,
					bottom: 20,
					textStyle: {
						color: '#333',
						fontSize: 16
					}
				},
				tooltip: {
					formatter: "<span style='display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#1890ff'></span>{b}：{c}"
				},
				color: _this.colors,
				grid: {
					x: 128,
					y: 40,
					x2: 50,
					y2: 20,
					show: true,
					borderWidth: 0,
				},
				label: {
					show: true,
					position: 'right',
					valueAnimation: true,
					color: '#333',
					formatter: '{@score}'
				},
				xAxis: {
					type: 'value',
					axisTick: {
						show: false
					},
					boundaryGap: [0, 0.01],
					splitLine: {
						show: true
					},
					axisLabel: {
						fontSize: 13,
						color: '#333'
					}
				},
				yAxis: {
					type: 'category',
					splitLine: {
						show: false
					},
					axisTick: {
						show: false
					},
					axisLine: {
						show: true
					},
					data: xline,
					axisLabel: {
						fontSize: 13,
						color: '#333'
					}
				},
				series: [{
					data: seriesline,
					type: 'bar',
					barWidth: 30,
				}]
			};
			chart.setOption(option);
			var startCharts = null;
			// 2、鼠标移动上去的时候的高亮动画
			// chart.on('mouseover', function(param) {
			// 	isSet = false
			// 	clearInterval(startCharts)
			// 	// 取消之前高亮的图形
			// 	chart.dispatchAction({
			// 		type: 'downplay',
			// 		seriesIndex: 0,
			// 		dataIndex: charPie3currentIndex
			// 	})
			// 	// 高亮当前图形
			// 	chart.dispatchAction({
			// 		type: 'highlight',
			// 		seriesIndex: 0,
			// 		dataIndex: param.dataIndex
			// 	})
			// 	// 显示 tooltip
			// 	chart.dispatchAction({
			// 		type: 'showTip',
			// 		seriesIndex: 0,
			// 		dataIndex: param.dataIndex
			// 	})
			// });
			// var chartHover = function() {
			// 	var dataLen = option.series[0].data.length
			// 	// 取消之前高亮的图形
			// 	chart.dispatchAction({
			// 		type: 'downplay',
			// 		seriesIndex: 0,
			// 		dataIndex: charPie3currentIndex
			// 	})
			// 	charPie3currentIndex = (charPie3currentIndex + 1) % dataLen
			// 	// 高亮当前图形
			// 	chart.dispatchAction({
			// 		type: 'highlight',
			// 		seriesIndex: 0,
			// 		dataIndex: charPie3currentIndex
			// 	})
			// 	// 显示 tooltip
			// 	chart.dispatchAction({
			// 		type: 'showTip',
			// 		seriesIndex: 0,
			// 		dataIndex: charPie3currentIndex
			// 	})
			// }
			// startCharts = setInterval(chartHover, 2000)
			// 4、鼠标移出之后，恢复自动高亮
			// chart.on('mouseout', function(param) {
			// 	if (!isSet) {
			// 		startCharts = setInterval(chartHover, 2000)
			// 		isSet = true
			// 	}
			// });
		},
		PiechartFun(el, data) {
			var charPie3currentIndex = 0,
				isSet = true; //为了做判断：当鼠标移动上去的时候，自动高亮就被取消
			var regionalchart = echarts.init(document.getElementById(el));
			for (var i = 0; i < data.length; i++) {
				data[i].value = data[i].num;
				data[i].name = data[i].notionName;
			}
			var _this = this;
			var option = {
				title: {
					text: ' ',
				},
				tooltip: {
					trigger: 'item'
				},
				// legend: {top: 'center',right:'15%',textStyle:{color:"#eee",fontSize:12,lineHeight:100},orient:'vertical',itemWidth:6,itemHeight:6, icon:'circle'	//图例圆形
				// },
				series: [{
					name: '',
					type: 'pie',
					radius: '60%',
					// center: ["52%", "50%"],
					data: data,
					label: {
						show: true,
						color: '#333',
						fontSize: 14,
						position: 'outside',
						formatter: '{b} : {d}%',
					},
					emphasis: {
						itemStyle: {
							shadowBlur: 10,
							shadowOffsetX: 0,
							shadowColor: 'rgba(0, 0, 0, 0.5)'
						}
					}
				}]
			};
			regionalchart.setOption(option);
		},
	},
}
</script>

<style>
/* 提示框箭头 */
.atooltip.el-tooltip__popper[x-placement^="top"] .popper__arrow {
	border-top-color: #E0E8F9;
}

.atooltip.el-tooltip__popper[x-placement^="top"] .popper__arrow:after {
	border-top-color: #E0E8F9;
}

/* 提示框背景色 */
.atooltip {
	background: #E0E8F9 !important;
}
</style>
